module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Poem-title",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("The Winds")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("The leaves have fallen")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The sky darker")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Autumns’ own lonely markers")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Leaves may fall")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But cases rise")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Sullen faces")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Masked disguise")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Pumpkins’ eyes light the night")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("For October is the mask season")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But now horror has other reason")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("People stand shoulder to shoulder")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Without a care")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("No thought for the older")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("To see them all flaunt the rules")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Diminish the losses")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Makes us all fools")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("And when the days are shorter")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("People move in")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Pulling crackers")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Hats worn without grin")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("But Thursday nights remain silent")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The silence is loud")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Of my record")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I’m still proud")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-146e1bfb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398433502_EPUB6.vue
// module id = 75
// module chunks = 0